// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3Q99C","bigColWidth":"Table_bigColWidth__1qsAe","biggerColWidth":"Table_biggerColWidth__3GgBG","row":"Table_row__1vxXu","col":"Table_col__397jP"};